import { ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';

export default {
  props: {
    reddotkey: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const active = ref(false);
    const prefixedReddotKey = `ents:${props.reddotkey}`;

    if (!window.localStorage.getItem(prefixedReddotKey)) {
      window.localStorage.setItem(prefixedReddotKey, true);
    }

    active.value = window.localStorage.getItem(prefixedReddotKey) === 'true';
    EventBus.on('reddot:read', (key) => {
      if (key === props.reddotkey) {
        window.localStorage.setItem(prefixedReddotKey, false);
        active.value = false;
      }
    });

    return {
      active,
    };
  },

  template:
    `<div :class="{'bewerten-reddot--visible': active, 'bewerten-reddot': !active}">
        <svg data-test-bewerten-reddot xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="currentColor"/>
        </svg>
        <slot></slot>
    </div>`,

};
